
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {mapState,mapMutations} from 'vuex'
import { getUserMoney } from '../service/getdata'
import QuotesSpotList from '../components/QuotesSpotList.vue'
export default{
components:{
XHeader,
Toast,
QuotesSpotList
},
data(){
return{
eyes: true, //资产是否隐藏
msg: "",
show: false,
userMoney: {}, //用户资金信息
showDialog: false,
selectedType: '2',
rechargeOptions: [
{ value: '1', label: '客服充值' },
{ value: '2', label: '数字货币' }
],
showDialog2: false,
selectedType2: '2',
}
},
computed:{
...mapState(['token'])
},
created(){
this.SETTOKEN()
this.getData()
},
methods:{
...mapMutations(['SETUSERDETAIL','SETUSER','SETTOKEN',"CLEAN_ALL"]),
getData(){
var that = this
this.$Loading()
getUserMoney({token: this.token}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){

(res.data.change_wallet ||[]).map( item =>{



let num = 4

item.change_balance = (+item.change_balance).toFixed(num)
item.money = (+item.money).toFixed(num)
item.lock_change_balance = (+item.lock_change_balance).toFixed(num)
item.money1 = (+item.money1).toFixed(num)
item.money2 = (+item.money2).toFixed(num)
item.price = (+item.price).toFixed(num)
item.secu_balance = (+item.secu_balance).toFixed(num)
item.wh_balance = (+item.wh_balance).toFixed(num)

return item
})

that.userMoney = res.data


}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}
}.bind(this),function(){
that.$Loading.close()
console.log("error")
})
},
sendMsg(content) {
this.msg = content;
this.show = true;
},

showRechargeDialog() {
this.showDialog = true;
},
closeDialog() {
this.showDialog = false;

},
confirmRecharge() {
if (!this.selectedType) {
this.sendMsg('请选择充值方式');
return;
}
if (this.selectedType === '1') {
this.$router.push('/pages/chat');
} else {
this.$router.push('/pages/rechargeType');
}
this.closeDialog();
},

showRechargeDialog2() {
this.showDialog2 = true;
},
closeDialog2() {
this.showDialog2 = false;

},
confirmRecharge2() {
if (!this.selectedType2) {
this.sendMsg('请选择提币方式');
return;
}
if (this.selectedType2 === '1') {
this.$router.push('/pages/bank');
} else {
this.$router.push('/pages/withdraw');
}
this.closeDialog2();
}

},
watch:{

}
}



// WEBPACK FOOTER //
// ./src/pages/funds.vue